import {AxiosError} from 'axios';
import {GET_COORDINATOR_PROFILE_URL} from 'web-library/constants/apiUrls';
import {GET_COORDINATOR_PROFILE_QUERY_KEY} from 'web-library/constants/queryKeys';
import {CoordinatorProfileResponse} from 'web-library/models/AccountManagementConfiguration';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: (res: CoordinatorProfileResponse) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
  enabled: boolean;
}

export const useGetCoordinatorProfile = ({onError, onSuccess, uuid, enabled}: Input) => {
  const getCoordinatorProfile = async () => {
    const res = await axiosClient.get<CoordinatorProfileResponse>(
        GET_COORDINATOR_PROFILE_URL(uuid)
    );

    return res.data;
  };

  return useCustomQuery([GET_COORDINATOR_PROFILE_QUERY_KEY, uuid], getCoordinatorProfile, {
    onSuccess,
    onError,
    enabled,
  });
};
